import React from 'react';
import _ from 'underscore';
import {
  TableColumnDefinition,
  TableCellLayout,
  createTableColumn,
} from '@fluentui/react-components';
import { EntityName } from '@bingads-webui-campaign-react/overview-grid-entity-name';

import { IColumnData, ISelectedMetric, TMajorMetric, IMetricFormatter } from './types';
import { MetricCell } from './table-cell/metric-cell';
import { MetricHeaderCell } from './table-cell/metric-header-cell';
import { EntityNameColumnId } from './const';

interface IGetColumnsProps {
  entityDisPlayName: string;
  selectedMetrics: ISelectedMetric[];
  allMetrics: ISelectedMetric[];
  onColumnChange: ({
    newSelectedMetrics,
  }: {
    newSelectedMetrics: ISelectedMetric[],
  }) => void;
  metricFormatter: IMetricFormatter;
  comparisonMajorMetric: TMajorMetric;
  i18n: any;
}

// TODO: [yaoyao] Do we show less columns in small screen? Designer should provide the design.
// https://msasg.visualstudio.com/Bing_Ads/_workitems/edit/7235904
export function getColumns({
  entityDisPlayName,
  selectedMetrics,
  allMetrics,
  onColumnChange,
  metricFormatter,
  comparisonMajorMetric,
  i18n,
}: IGetColumnsProps): TableColumnDefinition<IColumnData>[] {
  const dropdownMetrics = _.filter(allMetrics, metric => !selectedMetrics.some(m => m.key === metric.key));
  const metricColumns = _.map(selectedMetrics, (metric, index) => {
    const onMetricDropdownSelect = (key: string) => {
      const newSelectedMetrics = [...selectedMetrics];
      const selectedMetric = allMetrics.find(m => m.key === key);
      newSelectedMetrics.splice(index, 1, selectedMetric);
      onColumnChange({
        newSelectedMetrics,
      });
    };
    return createTableColumn<IColumnData>({
      columnId: metric.key,
      compare: (a, b) => a[comparisonMajorMetric][metric.key] - b[comparisonMajorMetric][metric.key],
      renderHeaderCell: () => (
        <MetricHeaderCell i18n={i18n} dropdownMetrics={dropdownMetrics} onMetricDropdownSelect={onMetricDropdownSelect} metricDisplayName={metric.displayName} />
      ),
      renderCell: item => (
        <MetricCell columnData={item} metricFormatter={metricFormatter} comparisonMajorMetric={comparisonMajorMetric} />
      ),
    });
  });

  return [
    createTableColumn<IColumnData>({
      columnId: EntityNameColumnId,
      renderHeaderCell: () => (
        <TableCellLayout truncate appearance="primary" >
          {entityDisPlayName}
        </TableCellLayout>
      ),
      renderCell: (item) => {
        let popoverContent = null;
        if (item.getPopoverContent) {
          popoverContent = item.getPopoverContent(item);
        }
        return (<EntityName
          entityType={item.entityType}
          href={item.href}
          name={item.Name}
          status={item.Status}
          isExperiment={!!item.Campaign?.ExperimentId || !!item.ExperimentId}
          popoverContent={popoverContent}
          triggerSearchTermDrawer={item.triggerSearchTermDrawer}
          className="entity-name-cell"
          i18n={i18n}
          searchTermStatus={item.SearchTermStatus}
          rowRawItem={item}
          logOnClick={item.logOnClick}
        />);
      },
    }),
    ...metricColumns,
  ];
}
